import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dbc27206&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=dbc27206&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc27206",
  null
  
)

export default component.exports